import React from 'react';
import { withLoading } from '@adjust/dashboard-components';

import { Plan } from '@api/types';
import { connectWithStore } from '@common/connectWithStore';
import { PricingPlansContentContainer } from '@react/Pages/AccountSettingsPage/PricingPlanPage/PricingPlansContent/PricingPlansContent.container';
import { AdditionalPackagesContainer } from '@react/Pages/AccountSettingsPage/PricingPlanPage/AdditionalPackages/AdditionalPackages.container';
import { PricingPeriodSwitchContainer } from '@react/Pages/AccountSettingsPage/PricingPlanPage/PricingPeriodSwitch/PricingPeriodSwitch.container';
import { ChangePricingPlanContainer } from '@react/Pages/AccountSettingsPage/PricingPlanPage/ChangePricingPlan/ChangePricingPlan.container';
import { getState } from '@redux/ducks/account/pricingPlan/pricingPlans';
import { confirmSucceed } from '@redux/ducks/account/pricingPlan/changePricingPlan';

import './PricingPlanPageContent.scss';

export interface PricingPlanPageContentOwnProps {
  isUpgrade: boolean;
  isOnboarding?: boolean;
}

export interface PricingPlanPageContentStateProps {
  currentPlan?: Plan;
}

export interface PricingPlanPageContentDispatchProps {
  confirmSucceed: () => void;
}

export type PricingPlanPageContentProps = PricingPlanPageContentOwnProps &
  PricingPlanPageContentStateProps &
  PricingPlanPageContentDispatchProps;

export const PricingPlanPageContent = ({
  isUpgrade,
  currentPlan,
  confirmSucceed,
  isOnboarding,
}: PricingPlanPageContentProps) => (
  <>
    <div className="pricing-title">
      <h2 className="pricing-title__header">
        {isUpgrade ? t('pricing-plan.time-for-an-upgrade.title') : t('pricing-plan.select-a-pricing-plan.title')}
      </h2>
    </div>

    <div className="pricing-plans-header">
      <PricingPeriodSwitchContainer />

      {isOnboarding && currentPlan && (
        <a className="pricing-plans-header__continue" onClick={confirmSucceed}>
          <span>{t('action.continue')}</span>
          <i className="icon-arrow-right flex-auto" />
        </a>
      )}
    </div>

    <PricingPlansContentContainer />

    <AdditionalPackagesContainer />

    <ChangePricingPlanContainer />
  </>
);

const mapStateToProps = state => {
  const { currentPlan } = getState(state);

  return {
    currentPlan,
  };
};

const mapDispatchToProps = {
  confirmSucceed,
};

export const PricingPlanPageContentWithLoading = connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(withLoading(PricingPlanPageContent));
